import { api } from './BaseApi'
import { IUserResponseDto } from './dto/UserDto'

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query<IUserResponseDto, void | {}>({
      query: () => ({
        url: '/user/current/',
      }),
      providesTags: ['User'],
    }),
  }),
})

export const { useGetCurrentUserQuery } = userApi
